var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOdt(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 4,
    x2: 28,
    y1: 31,
    y2: 1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#083fa6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2dcbfd",
    offset: 1
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "file_type_libreoffice_writer") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.875 0 0 .875 2 2)",
    fillRule: "evenodd",
    strokeLinecap: "square"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m7 0c-2.216 0-4 1.784-4 4v24c0 2.216 1.784 4 4 4h18c2.216 0 4-1.784 4-4v-16l-12-12zm13 0 9 9v-9z",
    fill: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3 27v1c0 2.216 1.784 4 4 4h18c2.216 0 4-1.784 4-4v-1c0 2.216-1.784 4-4 4h-18c-2.216 0-4-1.784-4-4z",
    fillOpacity: 0.19862
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20 0h1.4l7.6 7.6v1.4z",
    fillOpacity: 0.20149
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fafafa"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 13,
    width: 7,
    height: 1,
    ry: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 15,
    width: 7,
    height: 1,
    ry: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 17,
    width: 7,
    height: 1,
    ry: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 20,
    width: 16,
    height: 1,
    ry: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 22,
    width: 16,
    height: 1,
    ry: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 24,
    width: 7,
    height: 1,
    ry: 0.5
  })), /*#__PURE__*/React.createElement("path", {
    d: "m18 13c-0.554 0-1 0.446-1 1v3c0 0.554 0.446 1 1 1h5c0.554 0 1-0.446 1-1v-3c0-0.554-0.446-1-1-1zm4.5 1a0.5 0.5 0 0 1 0.5 0.5 0.5 0.5 0 0 1-0.5 0.5 0.5 0.5 0 0 1-0.5-0.5 0.5 0.5 0 0 1 0.5-0.5zm-3.1641 0.5293a0.61803 0.61803 0 0 1 0.37109 0.17773l2.293 2.293h-4l0.68359-2.0508a0.61803 0.61803 0 0 1 0.65234-0.41992z",
    fill: "#9ae9f9"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOdt);
export default __webpack_public_path__ + "static/media/odt.cdd7def545db1764ed642a310298aba7.svg";
export { ForwardRef as ReactComponent };